import { useTranslate, useRecordContext } from 'react-admin'
import {
  CardHeader,
  List as ListMui,
  ListItem,
  ListItemText,
  ListItemIcon,
  Paper,
  Box,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
} from '@material-ui/core'

import GetAppIcon from '@mui/icons-material/GetApp'
import { PreviewButton } from '../../components/file_upload'

export const EquipeViewForm = (props) => {
  const record = useRecordContext(props)
  const translate = useTranslate()
  if (!record) return null
  if (record.fiche_gardien == 'Oui') {
    return (
      <Box component={Paper}>
        <CardHeader title="Gardiens" />
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="left">Nom</TableCell>
              <TableCell align="left">Email</TableCell>
              <TableCell align="left">Téléphone</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!record.fiche_gardien1_nom && !record.fiche_gardien2_nom && (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  Aucun gardien renseigné
                </TableCell>
              </TableRow>
            )}
            {record.fiche_gardien1_nom && (
              <TableRow
                key={'gardien1'}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell align="left">{record.fiche_gardien1_nom}</TableCell>
                <TableCell align="left">
                  {record.fiche_gardien1_email}
                </TableCell>
                <TableCell align="left">{record.fiche_gardien1_tel}</TableCell>
              </TableRow>
            )}
            {record.fiche_gardien2_nom && (
              <TableRow
                key={'gardien2'}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell align="left">{record.fiche_gardien2_nom}</TableCell>
                <TableCell align="left">
                  {record.fiche_gardien2_email}
                </TableCell>
                <TableCell align="left">{record.fiche_gardien2_tel}</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <ListMui>
          {record.team_and_guards_documents?.map(
            ({ url, purpose, category }) => (
              <ListItem>
                <ListItemIcon
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    const link = document.createElement('a')
                    link.download = purpose
                    link.href = `${window.location.origin}${url}`
                    link.click()
                  }}
                >
                  <GetAppIcon color="primary" />
                </ListItemIcon>
                <ListItemIcon style={{ cursor: 'pointer' }}>
                  <PreviewButton record={{ url }} source="url" />
                </ListItemIcon>

                <ListItemText
                  primary={`${translate(
                    `hs.file.category.${category}`
                  )}: ${purpose}`}
                />
              </ListItem>
            )
          )}
        </ListMui>
      </Box>
    )
  }
  return null
}
